export class RivaasError extends Error {
  public constructor(
    public status?: string,
    public tracingId?: string,
    message?: string,
  ) {
    super(message ?? `Error occurred with status: ${status}`);
    this.name = 'RivaasError';
  }

  public getMetaData() {
    return {
      tracingId: this.tracingId,
      status: this.status,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public log(...optionalParams: any[]) {
    // eslint-disable-next-line
    console.error(this, ...optionalParams, JSON.stringify(this.getMetaData()));
  }
}
